class RabobankConfigController extends AbstractIntegrationController
	@register()
	@inject '$scope', 'IntegrationConfiguration'

	integrationId: 'rabobank'

	initialize: ->
		@configuration = @IntegrationConfiguration.data if not _.isEmpty(@IntegrationConfiguration.data)

	save: ->
		super(@configuration).then =>
			@configuration.active = true

	afterDisconnect: ->
		@configuration = {
			active: false
		}
